module.exports = __webpack_public_path__ + "static/media/feature_governance_framework.a833638b.png";